import React, { useState } from 'react';
import AudioPlayer from './AudioPlayer/AudioPlayer';
import Button from '../../../../Buttons/Button';
import * as constants from './../../../../../constants';
import './AudioHotspotPlayer.scss';

const AudioHotspotPlayer = ({
  audio = { tracks: {} },
  id,
  transcript = '',
}) => {
  const {
    tracks: { id: audioId, transcriptOnly },
  } = audio;
  const src = `${constants.AUDIOFILESURL}${audioId}`;

  const [showTranscript, setShowTranscript] = useState(true);
  const toggleTranscript = () => setShowTranscript(!showTranscript);

  return (
    <>
      {audioId ? (
        <div className="audio-player-transcript__wrapper">
          {!transcriptOnly && (
            <div className="audio-transcript-button_wrapper">
              <AudioPlayer className="audio-player" src={src} id={id} />
              {transcript && (
                <Button
                  className="audio-player__transcript-btn"
                  handleClick={toggleTranscript}
                  aria-label="Toggle audio transcript"
                >
                  <i className="material-icons" aria-hidden="true">
                    description
                  </i>
                </Button>
              )}
            </div>
          )}
          {transcript && showTranscript && (
            <div className={`audio-player__transcript`}>
              <article
                className="audio-hotspot-player__article"
                dangerouslySetInnerHTML={{
                  __html: transcript,
                }}
              />
            </div>
          )}
        </div>
      ) : (
        <p className="audio-media-not-found">No media content found</p>
      )}
    </>
  );
};

export default AudioHotspotPlayer;
